import styled from '@emotion/styled';
import { Typography } from 'antd';

export const SControl = styled.div`
  margin-top: 8px;
`;

export const SLabel = styled(Typography.Text)`
  text-transform: capitalize;
`;

export const SFooter = styled.div`
  display: flex;
  justify-content: flex-end;
`;
